import React, { useState, FormEvent, useEffect } from "react";
import "./Login.scss";
import httpClient from "../../services/httpClient";
import ROUTES, { appPathForRole } from "../../routes";
import store, { Stored, Message } from "../../services/store";
import { AxiosResponse } from "axios";
import Logo from "../../../assets/images/logo.png";
import LogoWhite from "../../../assets/images/logo_white.png";
import Background from "../../../assets/images/background.png";
import IconEmail from "../../../assets/images/icons/icon_email.svg";
import IconPassword from "../../../assets/images/icons/icon_password.svg";
import IconDisplayPassword from "../../../assets/images/icons/icon_display_password.svg";
import IconHidePassword from "../../../assets/images/icons/icon_hide_password.svg";
import LoginInput from "./LoginInput";
import { t } from "../../services/i18n";
import { useHistory } from "react-router-dom";
import CampaignRegistration from "../CampaignRegistration/CampaignRegistration";

export default () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  let [displayPassword, setDisplayPassword] = useState(false);
  const history = useHistory();
  const [campaignToken, setCampaignToken] = useState<string | null>(null);

  // Vérifier s'il y a un token de réinitialisation ou de campagne dans l'URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const resetToken = urlParams.get("token");
    const campaignTokenParam = urlParams.get("campaign_token");

    if (resetToken) {
      // Rediriger vers la page de réinitialisation avec le token
      history.push(`/reset_password/${resetToken}`);
    } else if (campaignTokenParam) {
      setCampaignToken(campaignTokenParam);
    } else {
      setCampaignToken(null);
    }
  }, [history]);

  // Les listeners de notifications sont maintenant configurés dans App.tsx

  const storeJWT = (resp: AxiosResponse) => {
    let token = resp.headers["authorization"].replace("Bearer ", "");
    let [rawJwt, jwt] = httpClient.storeCreds(token);

    store.update(Stored.JWT, jwt);
    store.update(Stored.RawJWT, rawJwt);
  };

  const submitLogin = async (e: FormEvent) => {
    e.preventDefault();

    try {
      await httpClient.req(
        ROUTES.LOGIN({
          email,
          password,
        }),
        undefined,
        storeJWT,
      );

      store.notify(Message.Notification, t("Vous êtes connecté avec succès"));
      const role =
        (httpClient.jwt as any)?.role ||
        (httpClient.jwt as any)?.userRole ||
        (httpClient.jwt as any)?.role_name;
      let target = appPathForRole(role);

      // Si l'utilisateur vient du lien "Connectez-vous" d'un test, le renvoyer vers l'apprenant avec le token pour lancer le quiz
      // Peu importe son rôle (manager, admin, etc.), les tests se passent dans l'app apprenant
      const fromTest = new URLSearchParams(window.location.search).get(
        "return_to_test",
      );
      if (fromTest) {
        target = `/apprenant?from_test=${encodeURIComponent(fromTest)}`;
      }

      if (target && target !== "/") {
        location.assign(target);
      }
    } catch (e) {
      // Gestion explicite de l'erreur pour s'assurer qu'une notification s'affiche
      store.notify(Message.Error, t("Email ou mot de passe incorrect"));
      console.warn("Login failed:", e);
    }
  };

  return (
    <div className="Login">
      <div className="Login__left">
        <div className="Login__leftWelcome">
          {t("Bienvenue sur la plateforme")}
        </div>
        <img src={Logo} className="Login__leftLogo" />
        {!campaignToken && (
          <>
            <div className="Login__leftHint">
              {t("Rentrez ici vos identifiants pour accéder à la plateforme")}
            </div>
            <form onSubmit={submitLogin}>
              <LoginInput
                icon={IconEmail}
                type="text"
                value={email}
                onChange={setEmail}
                placeholder={t("Email")}
              />
              <LoginInput
                icon={IconPassword}
                type={displayPassword ? "text" : "password"}
                value={password}
                onChange={setPassword}
                placeholder={t("Mot de passe")}
                after={displayPassword ? IconHidePassword : IconDisplayPassword}
                afterOnClick={() => setDisplayPassword((prev) => !prev)}
              />
              <input type="submit" value={t("Connexion")} />
              <a
                className="Login__leftForgottenPassword"
                href="#"
                onClick={(e) => {
                  e.preventDefault();

                  history.push("/reset_password");
                }}
              >
                {t("Vous avez oublié votre mot de passe ?")}
              </a>
            </form>
          </>
        )}
        {campaignToken && <CampaignRegistration token={campaignToken} />}
      </div>
      <div className="Login__right">
        <img src={Background} className="Login__rightBackground" />
        <div className="Login__rightOverlay" />
        <img src={LogoWhite} className="Login__rightLogo" />
        <div className="Login__rightText">
          {t(
            "Votre plate-forme de sensibilisation ludique. Apprenez, progressez et certifiez-vous !",
          )}
        </div>
      </div>
    </div>
  );
};
